import { render, staticRenderFns } from "./SaveGroupModal.vue?vue&type=template&id=b3093a9c"
import script from "./SaveGroupModal.vue?vue&type=script&lang=js"
export * from "./SaveGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports